export default __webpack_public_path__ + "static/media/cart.4ff4e469.png";